import { render, staticRenderFns } from "./TextOverlayGridButtons.vue?vue&type=template&id=1a3b9064&"
import script from "./TextOverlayGridButtons.vue?vue&type=script&lang=js&"
export * from "./TextOverlayGridButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports